import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SharedDataService, Supplier } from 'ngx-paf-common';
import { Subject, Subscription } from 'rxjs';

@Component({
  template:''
})
export abstract class PilotageEndelTabComponent implements OnInit, OnDestroy {
  private reloadSub?:Subscription = null;
  
  constructor(public sharedDataSvc:SharedDataService) { }

  @Input() public tabName:string;
  @Input() public reload?:Subject<string>;

  @Input() supplier? : Supplier;   
  @Input() supplierId? : number;

  @Output() editModeChange?:EventEmitter<boolean> = new EventEmitter<boolean>();
  
  private _loading:boolean = false;

  private  _editMode:boolean=false;
  get editMode():boolean{
    return this._editMode;
  }
  set editMode(value:boolean){
    if (value!= this._editMode){
      this._editMode = value;
      this.editModeChange.emit(value);
    }
  }

  get loading():boolean{
    return this._loading;
  }
  set loading(value:boolean){
    this._loading = value;
    if (value) {
        this.sharedDataSvc.WindowLock();
    } else {
      this.sharedDataSvc.WindowUnlock();
    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.reloadSub) this.reloadSub.unsubscribe();
    if (this.editModeChange) this.editModeChange.unsubscribe();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reload'] && this.reload){
      this.reloadSub = this.reload.subscribe((value:string)=> {if (value==this.tabName) this.reloadTab()});
    }
  }

  abstract reloadTab():void;
  
}
